import homeImg from 'assets/images/home.png';
import automationImg from 'assets/images/automation.png';
import managementImg from 'assets/images/manage.png';

const adminMenuItems = {
    id: 'general',
    title: 'General',
    type: 'group',
    children: [
        {
            id: 'home',
            title: 'Home',
            type: 'item',
            url: '/home',
            icon: homeImg,
            breadcrumbs: false,
            required: {
                server_admin: true,
                org_admin: true,
                group_admin: true
            }
        },
        {
            id: 'automation',
            title: 'Automation',
            type: 'item',
            url: '/automation',
            icon: automationImg,
            breadcrumbs: false,
            required: {
                server_admin: true,
                group_admin: true
            }
        },
        {
            id: 'management',
            title: 'Management',
            type: 'collapse',
            icon: managementImg,
            children: [
                {
                    id: 'devices',
                    title: 'Devices',
                    type: 'item',
                    url: '/management/devices',
                    breadcrumbs: false,
                    required: {
                        server_admin: true,
                        org_admin: true,
                        group_admin: true,
                        view: 1,
                        wake: 1
                    }
                },
                {
                    id: 'groups',
                    title: 'Groups',
                    type: 'item',
                    url: '/management/groups',
                    breadcrumbs: false,
                    required: {
                        server_admin: true,
                        org_admin: true,
                        group_admin: true
                    }
                },
                {
                    id: 'views',
                    title: 'Views',
                    type: 'item',
                    url: '/management/views',
                    breadcrumbs: false,
                    required: {
                        org_admin: true,
                        server_admin: true
                    }
                },
                {
                    id: 'policies',
                    title: 'Policies',
                    type: 'item',
                    url: '/management/policies',
                    breadcrumbs: false,
                    required: {
                        server_admin: true,
                        org_admin: true
                    }
                },
                {
                    id: 'license',
                    title: 'Licenses',
                    type: 'item',
                    url: '/management/licenses',
                    breadcrumbs: false
                },
                {
                    id: 'energy_rate',
                    title: 'Energy Rates',
                    type: 'item',
                    url: '/management/energy_rate',
                    breadcrumbs: false,
                    required: {
                        server_admin: true,
                        org_admin: true
                    }
                },
                {
                    id: 'reference',
                    title: 'Reference',
                    type: 'item',
                    url: '/management/reference',
                    breadcrumbs: false,
                    required: {
                        server_admin: true,
                        org_admin: true,
                        group_admin: true,
                        user_admin: true
                    }
                },
                {
                    id: 'users',
                    title: 'Users',
                    type: 'item',
                    url: '/management/users',
                    breadcrumbs: false,
                    required: {
                        server_admin: true,
                        org_admin: true,
                        group_admin: true,
                        user_admin: true
                    }
                },
                {
                    id: 'permissions',
                    title: 'Permissions',
                    type: 'item',
                    url: '/management/permissions',
                    breadcrumbs: false,
                    required: {
                        server_admin: true,
                        org_admin: true
                    }
                },
                {
                    id: 'organization',
                    title: 'Organizations',
                    type: 'item',
                    url: '/management/organizations',
                    breadcrumbs: false,
                    required: {
                        root_admin: true,
                        server_admin: true
                    }
                },
                {
                    id: 'notifications',
                    title: 'Notifications',
                    type: 'item',
                    url: '/management/notifications',
                    breadcrumbs: false,
                    required: {
                        server_admin: true
                    }
                }
            ]
        }
    ]
};

export default adminMenuItems;
